import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs0016',
    ecrans: ['00-2'],
    params: ['id']
});
